<template>
  <div class="section-card pax-card">
    <snackbarcomp v-model="snackbar" :mesaj="text1"></snackbarcomp>
    <adresaradialogcustom v-model="dialogShow" :kisi="passenger" @updatePassenger="updatePassenger" />

    <div class="card-header purple-bar">
      <div style="display:flex;align-items:center;gap:10px;">
        <div class="pax-number-badge">{{ index + 1 }}</div>
        <div>
          <div style="font-size:15px;font-weight:600;color:#1f2937;">{{ paxTitle }}</div>
        </div>
        <v-btn color="primary" @click="openDialog()" :disabled="disabled">
          {{ $t('Hotel-Search-Passenger') }} <v-icon>search</v-icon>
        </v-btn>
        <v-btn color="success" @click="savePassenger()" :disabled="disabled" style="margin-left: 8px;">
          {{ $t('Hotel-Save-Passenger') }} <v-icon>save</v-icon>
        </v-btn>
      </div>
      <v-checkbox @change="$emit('defaultContact', passenger, index)" :disabled="disabled" :value="contactIndex === index" :label="$t('Hotel-Default-Contact')" color="#667eea"
        hide-details class="mt-0 pt-0 shrink"></v-checkbox>
    </div>

    <div class="card-body">
      <v-layout row wrap>
        <v-flex xs12 sm6 pr-1>
          <v-text-field :label="$t('Name_label')" v-model="passenger.FirstName" @change="$emit('changeFirstName', passenger.FirstName)"
            :disabled="disabled" :rules="[rules.required]" outline></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field :label="$t('Surname_label')" v-model="passenger.LastName" @change="$emit('changeLastName', passenger.LastName)"
            :disabled="disabled" :rules="[rules.required]" outline></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 pr-1>
          <v-text-field :label="$t('Email_label')" v-model="passenger.Email" @change="$emit('changeEmail', passenger.Email)"
            :disabled="disabled" :rules="[rules.required, rules.email]" outline></v-text-field>
        </v-flex>
        <v-flex xs12 sm6>
          <phoneinput v-model="passenger.Phone" :rules="[rules.required]" :label="$t('Phone')" :locale="$i18n.locale"
            @change="$emit('changePhone', passenger.Phone)" :disabled="disabled" :hideDetails="false" />
        </v-flex>
        <v-flex xs12 sm6 pr-1>
          <v-select :label="$t('Sex-v2')" :items="genderItems" item-text="text" item-value="value" v-model="passenger.Gender"
            :rules="[rules.required]" :disabled="disabled" outline></v-select>
        </v-flex>
        <v-flex xs12 sm6>
          <tarihim :etiket="$t('Birth-Date')" :aktifmi="disabled" v-model="passenger.BirthDate" :detaygizle="false"
            :rules="getDateRules()" :min="birthDateRange.min" :max="birthDateRange.max"></tarihim>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import phoneinput from "@/components/app/customcomp/PhoneInputNew.vue";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import adresaradialogcustom from "@/components/app/customcomp/adresaradialogcustom.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp.vue";
import tool from "@/components/app/coper/tools.js";

export default {
  name: "HotelPassengerCard",
  components: {
    phoneinput,
    tarihim,
    adresaradialogcustom,
    snackbarcomp
  },
  props: {
    passenger: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    contactIndex: {
      type: Number,
      default: -1
    },
    genderItems: {
      type: Array,
      required: true
    },
    rules: {
      type: Object,
      required: true
    },
    checkInDate: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dialogShow: false,
      snackbar: false,
      text1: ""
    };
  },
  computed: {
    isChild() {
      return this.passenger.IsChild === true || this.passenger.PaxType === 1;
    },
    paxTitle() {
      return this.isChild ? this.$t('Hotel-Child-Passenger') : this.$t('Hotel-Adult-Passenger');
    },
    birthDateRange() {
      if (!this.isChild || this.passenger.ExpectedAge === null || this.passenger.ExpectedAge === undefined || isNaN(this.passenger.ExpectedAge)) {
        return { min: null, max: null };
      }
      const ref = this.checkInDate ? new Date(this.checkInDate.substring(0, 10)) : new Date();
      const age = Number(this.passenger.ExpectedAge);

      // Person is 'age' years old on check-in if born between:
      // Min (oldest): age+1 years ago, same month/day
      // Max (youngest): age years ago, same month/day
      const minDate = new Date(ref);
      minDate.setFullYear(minDate.getFullYear() - (age + 1));

      const maxDate = new Date(ref);
      maxDate.setFullYear(maxDate.getFullYear() - age);

      const toISO = (d) => d.toISOString().substring(0, 10);
      return { min: toISO(minDate), max: toISO(maxDate) };
    }
  },
  methods: {
    birthDateRule(v) {
      const { min, max } = this.birthDateRange;
      if (!v || !min || !max) return true;
      console.log(`Validating birth date: ${v}, min: ${min}, max: ${max}`);
      const date = `${v.substring(4, 8)}-${v.substring(2, 4)}-${v.substring(0, 2)}`; // Ensure we only take the date part
      // v comes from v-date-picker as YYYY-MM-DD format
      console.log(`Converted date for validation: ${date}`, `Min: ${min}, Max: ${max}`, `Date objects: ${new Date(date)}, ${new Date(min)}, ${new Date(max)}`, `Comparison results: ${new Date(date) >= new Date(min)}, ${new Date(date) <= new Date(max)}`);
      return (new Date(date) >= new Date(min) && new Date(date) <= new Date(max)) || this.$t('Hotel-Age-Validation', {age: this.passenger.ExpectedAge});
    },
    getDateRules() {
      const requiredRule = (v) => !!v || this.$t('Hotel-Select-Date');
      if (this.isChild) {
        return [requiredRule, this.birthDateRule];
      }
      return [requiredRule];
    },
    openDialog() {
      this.dialogShow = true;
    },
    updatePassenger(pax) {
      this.$emit("updatePassenger", pax, this.index);
      this.dialogShow = false;
    },
    savePassenger() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var endpoint = this.passenger.CoperKisiID ? 'AdresUpdate' : 'AdresInsert';
      if (!this.passenger.FirstName || !this.passenger.LastName) {
        this.text1 = this.$t('Hotel-Fill-Name-Surname');
        this.snackbar = true;
        return;
      }
      var params = {
        Value: {
          Id: this.passenger.CoperKisiID || 0, // for update vs create
          Ad: this.passenger.FirstName,
          Soyad: this.passenger.LastName,
          SirketNo: credentials.CoperSirketNo,
          Cinsiyet: this.passenger.Gender === "Male" ? "E" : (this.passenger.Gender === 'Female' ? 'K' : null),
          Ulke: this.passenger.Nationality,
          PasaportNo: this.passenger.PassportNo,
          BitisTarihi: this.passenger.PassportExpireDate,
          Uyruk: this.passenger.Nationality,
          GSM: this.passenger.Phone,
          TCKimlikNo: this.passenger.CitizenNo,
          Email: this.passenger.Email,
          DogumTarihi: this.passenger.BirthDate,
          MileCard: this.passenger.FrequentFlayerNo,
          TekerlekliSandalye: this.passenger.WheelChairService,
        },
      };
      tool.http_post(this, endpoint, params).then(
        (response) => {
          this.loadingcomp = false;
          if (response.body.Status == true) {
            this.text1 = this.$t('Hotel-Record-Added');
            this.snackbar = true;
            this.$emit("afterSave", response.body.data);
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
          this.loadingcomp = false;
          this.text1 = this.$t('An-error-has-occurred-Please-try-again');
          this.snackbar = true;
        }
      );
    }
  }
};
</script>

<style scoped>
.section-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 14px;
  overflow: hidden;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-top: 3px solid transparent;
}

.card-header.purple-bar {
  border-top-color: #667eea;
  background: #fafafa;
}

.card-body {
  padding: 14px 16px 4px;
}

.pax-number-badge {
  width: 28px;
  height: 28px;
  background: #667eea;
  border-radius: 50%;
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
